const updates = [
  { id: 1, date: '2026-07-29', title: '《霸道总裁的契约新娘》第87话更新上线', tag: '韩漫' },
  { id: 2, date: '2026-07-29', title: '《斗破乾坤之逆天改命》第203话更新上线', tag: '国漫' },
  { id: 3, date: '2026-07-28', title: '新作《暗黑系恋爱物语》第28话持续热更中', tag: '日漫' },
  { id: 4, date: '2026-07-28', title: '国漫专区新增5部玄幻修仙类作品全集', tag: '国漫' },
  { id: 5, date: '2026-07-27', title: '韩漫恋爱专题推荐页面全新上线', tag: '韩漫' },
  { id: 6, date: '2026-07-27', title: '下拉式阅读功能优化，加载速度提升40%', tag: '更新' },
  { id: 7, date: '2026-07-26', title: '羞羞漫画APP Android版v3.2.0更新发布', tag: '更新' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
            <i className="ri-timer-flash-line text-primary-500 text-xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">最新动态</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-[52px]">漫画更新与平台动态实时速递</p>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, index) => (
            <div
              key={item.id}
              className="group flex items-start gap-5 cursor-pointer"
            >
              <div className="flex flex-col items-center">
                <div className={`w-3 h-3 rounded-full flex-shrink-0 mt-1.5 ${index === 0 ? 'bg-primary-500 ring-4 ring-primary-100' : 'bg-background-300'}`}></div>
                {index < updates.length - 1 && (
                  <div className="w-0.5 h-full min-h-[40px] bg-background-200 mt-1 group-hover:bg-primary-200 transition-colors"></div>
                )}
              </div>
              <div className={`flex-1 pb-6 ${index === updates.length - 1 ? 'pb-0' : ''}`}>
                <div className="flex flex-wrap items-center gap-3 mb-1">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                  <span className={`px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
                    item.tag === '韩漫' ? 'bg-primary-100 text-primary-600' :
                    item.tag === '日漫' ? 'bg-accent-100 text-accent-600' :
                    item.tag === '国漫' ? 'bg-secondary-100 text-secondary-600' :
                    'bg-foreground-100 text-foreground-600'
                  }`}>{item.tag}</span>
                </div>
                <h3 className="text-sm text-foreground-700 group-hover:text-primary-500 transition-colors leading-relaxed">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}